import {
  BoxGeometry,
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Darius mesh — axe + Noxian red trim (OCP registry). */
export function createDariusMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x1d4ed8 : 0x991b1b;
  const armorMat = new MeshStandardMaterial({ color: 0x64748b, metalness: 0.7, roughness: 0.25 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.45 });
  const axeMat = new MeshStandardMaterial({ color: 0xcbd5e1, metalness: 0.85, roughness: 0.2 });

  const torso = new Mesh(new CylinderGeometry(0.8, 0.6, 2.3, 10), armorMat);
  torso.position.y = 2.0;
  group.add(torso);

  const head = new Mesh(new SphereGeometry(0.48, 12, 12), armorMat);
  head.position.y = 3.4;
  group.add(head);

  const pauldron = new Mesh(new BoxGeometry(0.9, 0.45, 0.7), trimMat);
  pauldron.position.set(-0.95, 2.9, 0);
  group.add(pauldron);

  const axe = new Mesh(new ConeGeometry(0.35, 1.6, 6), axeMat);
  axe.rotation.z = Math.PI / 2;
  axe.position.set(0.95, 2.2, 0.3);
  group.add(axe);

  return group;
}
